import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAdmin } from '../../hooks/useAdmin';
import { useWallet } from '../../context/WalletContext';

// Bottom nav bar — mobile-app style. 3 primary items + Admin (when eligible).
const BottomNav = () => {
  const { connected } = useWallet();
  const { isElevated, hasLoaded: adminChecked } = useAdmin();

  if (!connected) return null;

  const items = [
    { to: '/', end: true, label: 'Home', icon: HomeIcon },
    { to: '/packages', label: 'Packages', icon: PackagesIcon },
    { to: '/team', label: 'Team', icon: TeamIcon }
  ];

  if (adminChecked && isElevated) {
    items.push({ to: '/admin', label: 'Admin', icon: AdminIcon });
  }

  return (
    <nav className="bottom-nav" aria-label="Primary">
      <div className="bottom-nav-inner">
        {items.map((it) => (
          <NavLink
            key={it.to}
            to={it.to}
            end={it.end}
            className={({ isActive }) => 'bottom-nav-item' + (isActive ? ' active' : '')}
          >
            <div className="bottom-nav-icon"><it.icon /></div>
            <div className="bottom-nav-label">{it.label}</div>
          </NavLink>
        ))}
      </div>
    </nav>
  );
};

// SVG icons — inline so no external requests
const HomeIcon = () => (
  <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
    <polyline points="9 22 9 12 15 12 15 22"/>
  </svg>
);

const PackagesIcon = () => (
  <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
    <polyline points="3.27 6.96 12 12.01 20.73 6.96"/>
    <line x1="12" y1="22.08" x2="12" y2="12"/>
  </svg>
);

const TeamIcon = () => (
  <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
    <circle cx="9" cy="7" r="4"/>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
  </svg>
);

const AdminIcon = () => (
  <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
    <polyline points="9 12 11 14 15 10"/>
  </svg>
);

export default BottomNav;
